var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #002c5f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18768",
    "data-name": "Group 18768",
    transform: "translate(-1384 -8099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18396",
    "data-name": "Rectangle 18396",
    className: "cls-1",
    width: 38,
    height: 38,
    rx: 6,
    transform: "translate(1384 8099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7558",
    "data-name": "Path 7558",
    className: "cls-2",
    d: "M47.085,38.745a3.144,3.144,0,0,0-2.221-2.221C42.906,36,35.055,36,35.055,36s-7.851,0-9.809.525a3.149,3.149,0,0,0-2.221,2.221,35.074,35.074,0,0,0,0,12.086,3.144,3.144,0,0,0,2.221,2.221c1.959.525,9.809.525,9.809.525s7.851,0,9.809-.525a3.149,3.149,0,0,0,2.221-2.221,35.074,35.074,0,0,0,0-12.086ZM32.544,48.555V41.022l6.523,3.766Z",
    transform: "translate(1367.777 8073.044)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/Icon_youtube.c6fda3e6e12ce3d4216517cfc927e7c9.svg";
export { ForwardRef as ReactComponent };